import { Navigate, Outlet } from "react-router-dom";
import useAuthStore from "./zustand-stores/AuthStore";

const PublicRoute = () => {
  const { authStateLoading, authSessionExists } = useAuthStore();

  if (authStateLoading) {
    return <div>Loading...</div>;
  }

  return authSessionExists ? <Navigate to="/dashboard" replace /> : <Outlet />;
};

export default PublicRoute;
